import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Crown, MessageCircle } from 'lucide-react';
import { formatTimeUntilReset, RATE_LIMITS } from '../lib/rateLimits';
import { useLanguage } from '../context/LanguageContext';
import './RateLimitMessage.css';

export default function RateLimitMessage({ result, feature, onClose }) {
  const { reason, limit, isPro, minutesUntilReset } = result;
  const { t } = useLanguage();

  if (reason === 'pro_required') {
    return (
      <div className="rlm">
        <div className="rlm__icon rlm__icon--pro"><Crown size={28} /></div>
        <h3 className="rlm__title">{t('rateLimit.proOnlyTitle')}</h3>
        <p className="rlm__body">{t('rateLimit.proOnlyBody')}</p>
        <div className="rlm__actions">
          <Link to="/pro" className="rlm__btn rlm__btn--primary">{t('rateLimit.upgradeToPro')}</Link>
          {onClose && <button onClick={onClose} className="rlm__btn rlm__btn--ghost">{t('common.close')}</button>}
        </div>
      </div>
    );
  }

  if (reason === 'not_logged_in') {
    return (
      <div className="rlm">
        <h3 className="rlm__title">{t('rateLimit.signInTitle')}</h3>
        <p className="rlm__body">{t('rateLimit.signInBody')}</p>
        <div className="rlm__actions">
          <Link to="/login" className="rlm__btn rlm__btn--primary">{t('rateLimit.signIn')}</Link>
        </div>
      </div>
    );
  }

  const proLimit = RATE_LIMITS[feature]?.pro;
  const showProHint = !isPro && proLimit && proLimit !== Infinity;

  return (
    <div className="rlm">
      <div className="rlm__icon"><Clock size={28} /></div>
      <h3 className="rlm__title">{t('rateLimit.limitTitle')}</h3>
      <p className="rlm__body">
        {t('rateLimit.limitBodyPrefix')}{limit}{t('rateLimit.limitBodyMid')}{feature}{t('rateLimit.limitBodySuffix')}
        <br />
        <strong>{t('rateLimit.resetsInPrefix')}{formatTimeUntilReset(minutesUntilReset)}{t('rateLimit.resetsInSuffix')}</strong>
      </p>
      <div className="rlm__actions">
        <Link to="/contact" className="rlm__btn rlm__btn--primary">
          <MessageCircle size={16} /> {t('rateLimit.contactHelp')}
        </Link>
        {!isPro && (
          <Link to="/pro" className="rlm__btn rlm__btn--secondary">
            <Crown size={16} /> {t('rateLimit.upgradeHigher')}
          </Link>
        )}
        {onClose && <button onClick={onClose} className="rlm__btn rlm__btn--text">{t('common.close')}</button>}
      </div>
      {showProHint && (
        <p className="rlm__hint">{t('rateLimit.proHintPrefix')}{proLimit}{t('rateLimit.proHintSuffix')}</p>
      )}
    </div>
  );
}
